import { LogSeverityLevel } from "../Entities/LogSeverityLevel";

export class LogDto {
	public Message: string;
	public Level: LogSeverityLevel;
	public Properties: { [key: string]: string }
}